import "./AppChanges.css";

type AppChangesProps = {
    submitText?: string;
    saveDisabled?: boolean;
    onSubmit: () => void;
    onCancel: () => void;
}

export const AppChanges = ({submitText = "Submit", saveDisabled = false, onSubmit, onCancel} : AppChangesProps) => {

    return (
        <div className="app-changes">
            Changes have been made
            <button 
                className="button-cancel"
                onClick={onCancel}
            >
                Cancel
            </button>
            <button 
                className="button-save"
                onClick={onSubmit}
                disabled={saveDisabled}
            >
                {submitText}
            </button>
            
        </div>
    )
}